var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete / undefined / Glyph: undefined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7236 5.3418H14.7236C14.7236 4.23723 13.8282 3.3418 12.7236 3.3418C11.619 3.3418 10.7236 4.23723 10.7236 5.3418ZM9.22363 5.3418C9.22363 3.4088 10.7906 1.8418 12.7236 1.8418C14.6566 1.8418 16.2236 3.4088 16.2236 5.3418H21.9736C22.3878 5.3418 22.7236 5.67759 22.7236 6.0918C22.7236 6.50601 22.3878 6.8418 21.9736 6.8418H20.6545L19.4825 18.953C19.2965 20.8752 17.6811 22.3418 15.7499 22.3418H9.69732C7.76617 22.3418 6.15078 20.8752 5.96476 18.953L4.79271 6.8418H3.47363C3.05942 6.8418 2.72363 6.50601 2.72363 6.0918C2.72363 5.67759 3.05942 5.3418 3.47363 5.3418H9.22363ZM11.2236 10.0918C11.2236 9.67759 10.8878 9.3418 10.4736 9.3418C10.0594 9.3418 9.72363 9.67759 9.72363 10.0918V17.5918C9.72363 18.006 10.0594 18.3418 10.4736 18.3418C10.8878 18.3418 11.2236 18.006 11.2236 17.5918V10.0918ZM14.9736 9.3418C15.3878 9.3418 15.7236 9.67759 15.7236 10.0918V17.5918C15.7236 18.006 15.3878 18.3418 14.9736 18.3418C14.5594 18.3418 14.2236 18.006 14.2236 17.5918V10.0918C14.2236 9.67759 14.5594 9.3418 14.9736 9.3418ZM7.45779 18.8085C7.5694 19.9618 8.53863 20.8418 9.69732 20.8418H15.7499C16.9086 20.8418 17.8778 19.9618 17.9894 18.8085L19.1475 6.8418H6.29971L7.45779 18.8085Z",
    fill: "#ABABAB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGray);
export default __webpack_public_path__ + "static/media/trash-gray.7677a3836dda7a96a6e93caefb70b70c.svg";
export { ForwardRef as ReactComponent };